import { HttpClient } from '@angular/common/http';
import { Injectable, computed, signal } from '@angular/core';
import { CmsResponse } from '@models/cms/cms.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CmsService {
  constructor(private httpClient: HttpClient) {}
  protected _cmsInfo = signal<CmsResponse | null>(null);
  public cmsInfo = computed(() => this._cmsInfo());

  getCmsNotification(slug: string): Observable<CmsResponse> {
    return this.httpClient.get<CmsResponse>('cms/slug/' + slug);
  }

  getCms(slug: string) {
    this.getCmsNotification(slug).subscribe(res => {
      this._cmsInfo.set(res);
    });
  }
}
